export default __webpack_public_path__ + "static/media/drag.6434dc0c.svg";